import Header from '@/components/header';
import { GoBackButton } from '@/components/header/goBackButton';
import { useAuth } from '@/hooks/use-auth';
import { useGoBack } from '@/hooks/useGoBack';
import { MainWrap } from '@/styles/common';
import { themeVar } from '@/styles/theme';
import { TenantType } from '@trace-8/trace8-schema';
import { Helmet as Head } from 'react-helmet';
import styled from 'styled-components';
import useRefresh from '../../hooks/use-refresh';

const GenericError = () => {
  useRefresh();
  const goBack = useGoBack();
  const { user } = useAuth();

  const fallBackPath = user ? (user?.tenant?.type === TenantType.ADVISORY_FIRM ? '/dealCatalog' : '/dealPipeline') : '/login';

  return (
    <>
      <Head>
        <title>Generic Error</title>
      </Head>
      <MainWrap>
        <Header modalControl={<GoBackButton handleClose={() => goBack({ fallBack: fallBackPath })} />} />
        <GenericErrorWrapper>
          <GenericErrorTitle>There is nothing here!</GenericErrorTitle>
          <GenericErrorDescription>
            When this happens, it's usually because of a malformed URL, restricted permissions, or because something has been deleted.
          </GenericErrorDescription>
        </GenericErrorWrapper>
      </MainWrap>
    </>
  );
};

export default GenericError;

const GenericErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 300px 50px 40px 50px;
`;

const GenericErrorTitle = styled.h1`
  text-align: center;
  font-family: Lato;
  font-size: 80px;
  font-style: normal;
  font-weight: 300;
  line-height: 70px;
  color: ${themeVar('font.weak')};
`;

const GenericErrorDescription = styled.p`
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  color: ${themeVar('font.weak')};
`;
